import React, { Component } from 'react'
import { connect } from 'react-redux'
import {setRoomControlPage} from '../../../../action/action'
import {setCurrentWindow} from '../../../../../action/action'
import {setTint, getTintControlData} from '../../../../../action/roomControlAction'
import icon1 from '../assets/ico_tint_alt_01.svg'
import icon2 from '../assets/ico_tint_alt_02.svg'
import icon3 from '../assets/ico_tint_alt_03.svg'
import icon4 from '../assets/ico_tint_alt_04.svg'
import view_logo from '../assets/view_sw_logo.png'
import MiniLoader from '../../../../UI/MiniLoader'

const icon_1 = icon1
const icon_2 = icon2
const icon_3 = icon3
const icon_4 = icon4

class WindowTintControl extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            value: 0,
            value2 : 50,
            selectedLevel : null,
            clickedLevel: null,
            showLoader: false,
            levels: [
                {
                    "level" : "Level 1",
                    "value" : "1",
                    "icon": "icon_1"
                },{
                    "level" : "Level 2",
                    "value" : "2",
                    "icon": "icon_2"
                },{
                    "level" : "Level 3",
                    "value" : "3",
                    "icon": "icon_3"
                },{
                    "level" : "Level 4",
                    "value" : "4",
                    "icon": "icon_4"
                },
            ]
        }
    }

    onTintLevelClick = (level) => {
        this.setState({
            showLoader: true,
            clickedLevel: level
        })
        this.props.setTint(this.props.guestDetail, this.props.currentWindow[0].tintCode, level, this, this.callBack)
    }

    callBack = (status, level, self) => {
        console.log('callback from tint', status, level)
        if(status){
            if(self.state.clickedLevel == level){
                self.setState({
                    selectedLevel: level,
                    showLoader: false 
                })
                let index = self.props.currentWindow[1]
                let windows = [...self.props.windows]
                windows[index].currentState = level
            }
            if(window.FireBasePlugin){
                window.FirebasePlugin.logError("got the set tint response, updated the state")
              }
        } else {
            self.setState({
                showLoader: false 
            })
            if(window.FireBasePlugin){
                window.FirebasePlugin.logError("api faild for set tint")
              }
        }
    }

    componentDidMount() {
        this.setState({
            selectedLevel: this.props.currentWindow[0].currentState
        })
    }

    render(){
        return(
            <div className="main-container">
                <header className="inner-pages subpages" style = {{background: this.props.menuColor.assetBackgroundSelectorColor, boxShadow:"unset",border:"none", position: "sticky"}}>
                    {/* <a onClick={() => {this.props.setRoomControlPage('roomTheme')}} className="button-back"></a> */}
                    <a onClick={() => this.props.setCurrentWindow(null)} className="button-back"></a>
                    <div className="heading align-center">
                        <p className="bold" style={{color: '#fff'}}>{this.props.currentWindow[0].tintLabel}</p>
                    </div>
                </header>
                <section id="customizeRoom" class="widgets padding-bottom-2 margin-0">
                    <div class="widgets">
                        <div class="row">
                            <div class="col">
                                <p class="heading">Adjust window Tint</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-2">
                                {this.state.levels.map((obj) => {
                                    return (
                                        <a id="Level-1" class={`tile-sm thumbnails tile-container ${this.state.selectedLevel == obj.value && "selected"}`} onClick={() => this.onTintLevelClick(obj.value)} >
                                            { this.state.showLoader && this.state.clickedLevel == obj.value && <MiniLoader /> }
                                            <div class="thumb-img">
                                                <img src={eval(obj.icon)} />
                                            </div>
                                            <div class="thumb-text align-center">
                                                <p class="thumb-heading">{obj.level}</p>
                                            </div>
                                        </a>
                                    )
                                })}
                            </div>
                        </div>
                        <div class="row">
                        <div class="col">
                            <p class="desc align-center">Tint transitions are not immediate and can take up to 30 minutes.</p>
                            <img src={view_logo} class="ctl-logo" />
                        </div>
                        </div>
                    </div>
                </section>                
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
    guestDetail: state.store.home.guestDetails,
    menuColor: state.store.home.MenuColor,
    currentWindow: state.store.currentWindow,
    windows: state.store.TintControlData
}
}
export default connect(
    mapStateToProps,
    {
        setRoomControlPage,
        setTint,
        getTintControlData,
        setCurrentWindow
    }
)(WindowTintControl);